var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconServiceCongrats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.269,
    height: 61.471,
    viewBox: "0 0 57.269 61.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38750",
    "data-name": "\\uADF8\\uB8F9 38750",
    transform: "translate(-429.787 -1993.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19481",
    "data-name": "\\uD328\\uC2A4 19481",
    d: "M421.944,663.692a6.312,6.312,0,0,0,1.109-3.582,5.8,5.8,0,0,0-5.542-6.024,5.514,5.514,0,0,0-4.983,3.434,5.518,5.518,0,0,0-4.985-3.434A5.8,5.8,0,0,0,402,660.11a6.321,6.321,0,0,0,1.111,3.584l-.011.005.086.1c.282.393,9.341,10.153,9.341,10.153s9.056-9.758,9.336-10.149l.092-.1Z",
    transform: "translate(46.013 1340.247)",
    fill: "none",
    stroke: "#f09",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19482",
    "data-name": "\\uD328\\uC2A4 19482",
    d: "M416.964,740.566v-17.3c0-2.784-1.867-5.061-4.148-5.061H366.607c-2.28,0-4.148,2.277-4.148,5.061v17.3Z",
    transform: "translate(68.893 1312.839)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19483",
    "data-name": "\\uD328\\uC2A4 19483",
    d: "M414.412,706.561V694.5c0-1.941-1.177-3.528-2.614-3.528H382.669c-1.438,0-2.615,1.587-2.615,3.529v12.061Z",
    transform: "translate(61.372 1324.479)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19484",
    "data-name": "\\uD328\\uC2A4 19484",
    d: "M1199.557,1250.446s4.112,1.678,8.615-2.1,9.113,1.234,9.113,1.234,3.834,3.741,9.207-.7,10.627.119,10.627.119a7.661,7.661,0,0,0,9.188,0c5.072-3.442,7.121-.925,7.121-.925",
    transform: "translate(-768.205 791.368)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19485",
    "data-name": "\\uD328\\uC2A4 19485",
    d: "M1199.557,1249.385s2.665,1.171,5.584-1.464,5.907.862,5.907.862,2.485,2.611,5.968-.491,6.889.083,6.889.083a4.7,4.7,0,0,0,5.955,0c3.288-2.4,4.616-.646,4.616-.646",
    transform: "translate(-758.132 774.058)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceCongrats);
export default __webpack_public_path__ + "static/media/icon-service-congrats.6ccf7a2138fb8233c705f01313cfb7da.svg";
export { ForwardRef as ReactComponent };